// ** Core JWT Import
import useJwtServiceForWorkspace from '@src/@core/auth/jwt/useJwtForWorkspace'

const { jwt } = useJwtServiceForWorkspace({})

export default jwt
